export default "__VITE_ASSET__1db03a4d__"